import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Input, Button, Space, Select, Row, Col, Card, Carousel, Image } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Slider from "../components/base/Slider";
import Newsletter from "../components/Newsletter";
import { publicBlogService, advertisementService } from "../services/publicApi";

const Home = () => {
  const navigate = useNavigate();
  
  const [search, setSearch] = useState('');
  const [homeCategory, setHomeCategory] = useState();
  const [blogs, setBlogs] = useState([]);
  const [advertisements, setAdvertisements] = useState([]);

  const toEmbedUrl = (raw) => {
    if (!raw) return '';
    let url = String(raw).trim();
    if (/^www\./i.test(url)) url = `https://${url}`;
    if (/^(youtube\.com|m\.youtube\.com|youtu\.be)/i.test(url)) url = `https://${url}`;
    try {
      const u = new URL(url);
      // YouTube: watch?v=ID
      if ((/youtube\.com$/i.test(u.hostname) || /m\.youtube\.com$/i.test(u.hostname) || /youtu\.be$/i.test(u.hostname) || /youtube-nocookie\.com$/i.test(u.hostname))) {
        // youtu.be/ID
        if (u.hostname.includes('youtu.be')) {
          const id = u.pathname.replace('/', '');
          return id ? `https://www.youtube-nocookie.com/embed/${id}` : '';
        }
        // shorts/ID
        if (u.pathname.startsWith('/shorts/')) {
          const id = u.pathname.split('/')[2];
          return id ? `https://www.youtube-nocookie.com/embed/${id}` : '';
        }
        // watch?v=ID
        const idParam = u.searchParams.get('v');
        if (idParam) return `https://www.youtube-nocookie.com/embed/${idParam}`;
        // already embed
        if (u.pathname.startsWith('/embed/')) {
          return `https://www.youtube-nocookie.com${u.pathname}${u.search}`;
        }
      }
    } catch (e) {
      // ignore
    }
    return url;
  };

  useEffect(() => {
    (async () => {
      try {
        // Charger les blogs
        const items = await publicBlogService.getPublicBlogs(12);
        setBlogs(Array.isArray(items) ? items : []);
        
        // Charger les publicités actives
        const adResponse = await advertisementService.getActiveAdvertisements();
        setAdvertisements(adResponse || []);
      } catch (e) {
        setBlogs([]);
        setAdvertisements([]);
      }
    })();
  }, []);

  // Styles pour les overlays des partenaires et projets
  const partnerStyles = `
    .partner-card {
      position: relative;
      overflow: hidden;
      border-radius: 12px;
      transition: all 0.3s ease;
    }
    
    .partner-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }
    
    .partner-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: all 0.3s ease;
      border-radius: 12px;
    }
    
    .partner-card:hover .partner-overlay {
      opacity: 1;
    }
    
    .partner-link {
      color: white;
      text-decoration: none;
      padding: 12px 24px;
      background: linear-gradient(45deg, #667eea, #764ba2);
      border-radius: 25px;
      font-weight: 500;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    }
    
    .partner-link:hover {
      transform: scale(1.05);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
      color: white;
    }
    
    .project-overlay {
      opacity: 0;
    }
    
    .ant-card:hover .project-overlay {
      opacity: 1;
    }
    
    .ant-card:hover .ant-image {
      transform: scale(1.05);
    }
  `;

  // Fonction pour naviguer vers les produits avec la catégorie sélectionnée
  const handleCategoryClick = (categoryName) => {
    // Mapper les noms d'affichage vers les slugs de catégories
    const categorySlugs = {
      'Détection incendie': 'detection-incendie',
      'Éclairage sécurité': 'eclairage-securite',
      'Onduleurs': 'onduleurs',
      'Extinction automatique': 'extinction-automatique',
      'Contrôle d\'accès': 'controle-acces',
      'Vidéosurveillance': 'videosurveillance',
      'Alarmes intrusion': 'alarmes-intrusion',
      'Réseaux informatiques': 'reseaux-informatiques',
      'Interphonie': 'interphonie',
      'GRMS': 'grms',
      'Audio professionnel': 'audio-professionnel',
      'Détection de gaz': 'detection-de-gaz'
    };
    
    const categorySlug = categorySlugs[categoryName];
    if (categorySlug) {
      navigate(`/produits?category=${categorySlug}`);
    } else {
      navigate('/produits');
    }
  };

  const submitSearch = () => {
    const q = (search || '').trim();
    const params = new URLSearchParams();
    
    if (q) {
      params.set('search', q);
    }
    
    if (homeCategory) {
      params.set('category', homeCategory);
    }
    
    const qs = params.toString();
    navigate(qs ? `/produits?${qs}` : '/produits');
  };

  const onEnter = (e) => {
    if (e.key === 'Enter') submitSearch();
  };
  
  // Publicités depuis l'admin, ou placeholder si aucune
  const safeAdvertisements = Array.isArray(advertisements) ? advertisements : [];
  const hasAds = safeAdvertisements.length > 0;

  return (
    <div className="home">
      <style>{partnerStyles}</style>
      {/* Promo Slider Section */}
      <section className="hero-compact mt-header">
        <div className="container">
          {hasAds ? (
            <Slider slides={safeAdvertisements} autoPlay={true} autoPlayDelay={7000} />
          ) : (
            <div className="sld-placeholder">
              <div className="sld-placeholder-content">
                <i className="fas fa-image"></i>
                <h2><span style={{color:'#54ba66'}}>D</span>OMO<span style={{color:'#54ba66'}}>E</span>LEC</h2>
                <p>Votre partenaire en solutions électriques professionnelles</p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Statistics Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon" style={{ color: '#54ba66' }}>
                <i className="fas fa-tools"></i>
              </div>
              <div className="stat-text">
                <h3>500+</h3>
                <p>Installations réalisées</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon" style={{ color: '#54ba66' }}>
                <i className="fas fa-award"></i>
              </div>
              <div className="stat-text">
                <h3>+13 ans</h3>
                <p>D'expérience</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon" style={{ color: '#54ba66' }}>
                <i className="fas fa-clock"></i>
              </div>
              <div className="stat-text">
                <h3>24h</h3>
                <p>Intervention d'urgence</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon" style={{ color: '#54ba66' }}>
                <i className="fas fa-boxes"></i>
              </div>
              <div className="stat-text">
                <h3>+2000</h3>
                <p>Produits</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="main-content">
        <div className="container">
          <div className="content-grid">
            {/* Products Section - Nouveau style */}
            <div className="products-section-modern">
              <div className="section-head">
                <h2>Nos produits</h2>
                <a className="link-see-all" href="/produits">Voir tout</a>
              </div>
              <div className="products-modern-grid">
                {[
                  { icon: 'fas fa-fire', label: 'Détection incendie', color: '#54ba66' },
                  { icon: 'fas fa-bolt', label: 'Éclairage sécurité', color: '#54ba66' },
                  { icon: 'fas fa-car-battery', label: 'Onduleurs', color: '#54ba66' },
                  { icon: 'fas fa-spray-can', label: 'Extinction automatique', color: '#54ba66' },
                  { icon: 'fas fa-fingerprint', label: "Contrôle d'accès", color: '#54ba66' },
                  { icon: 'fas fa-camera', label: 'Vidéosurveillance', color: '#54ba66' },
                  { icon: 'fas fa-shield-alt', label: 'Alarmes intrusion', color: '#54ba66' },
                  { icon: 'fas fa-project-diagram', label: 'Réseaux informatiques', color: '#54ba66' },
                  { icon: 'fas fa-phone-alt', label: 'Interphonie', color: '#54ba66' },
                  { icon: 'fas fa-building', label: 'GRMS', color: '#54ba66' },
                  { icon: 'fas fa-headphones-alt', label: 'Audio professionnel', color: '#54ba66' },
                  { icon: 'fas fa-smog', label: 'Détection de gaz', color: '#54ba66' }
                ].map((c) => (
                  <div 
                    key={c.label} 
                    className="product-card-modern" 
                    onClick={() => handleCategoryClick(c.label)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="pc-icon" style={{ background: 'transparent', color: c.color }}>
                      <i className={c.icon}></i>
                    </div>
                    <div className="pc-content">
                      <h3>{c.label}</h3>
                      <span>Découvrir</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Tablette Surface style avec vidéo */}
            <div className="surface-promo">
              <div className="surface-wrapper">
                {/* Stand / Pied arrière */}
                <div className="surface-stand"></div>
                {/* Tablette */}
                <div className="surface-device">
                  <div className="surface-bezel">
                    <div className="surface-camera"></div>
                    <div className="surface-screen">
                      <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="surface-video"
                      >
                        <source src="/images/domoelec.mp4" type="video/mp4" />
                      </video>
                      {/* Fallback animé */}
                      <div className="surface-fallback">
                        <div className="surface-fb-glow"></div>
                        <div className="surface-fb-logo">
                          <img src="/images/logofav.png" alt="DOMOELEC" />
                        </div>
                        <h3><span className="hdr-green">D</span>OMO<span className="hdr-green">E</span>LEC</h3>
                        <p>Solutions électriques professionnelles</p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Ombre au sol */}
                <div className="surface-shadow"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nos partenaires */}
      <section className="partners-section">
        <div className="container">
          <div className="partners-head">
            <h2>Nos marques partenaires</h2>
          </div>
          <div className="partners-grid">
          
            <div className="partner-card">
              <img src="/images/ZENNIO.png"  />
           
            </div>
            <div className="partner-card">
              <img src="/images/hikvision.png"  />
           
            </div>
            <div className="partner-card">
              <img src="/images/aguilera.png"  />
           
            </div>
            <div className="partner-card">
              <img src="/images/Cooper.svg"  />
           
            </div>
            <div className="partner-card">
              <img src="/images/eaton.png" alt="Eaton" />
        
            </div>
            <div className="partner-card">
              <img src="/images/SENSITRON.jpg" />
             
            </div>
            <div className="partner-card">
              <img src="/images/legrand.png" alt="Legrand" />
            
            </div>
            <div className="partner-card">
              <img src="/images/NUGELEC.png"  />
            
            </div>
          </div>
        </div>
      </section>

      {/* Blog vidéo */}
      <section className="video-blog-section" style={{ padding: '50px 0',paddingBottom: '40px' }}>
        <div className="container">
          <div className="section-head">
            <h2>Blog vidéo</h2>
          </div>
          {(() => {
            const videoBlogs = (blogs || []).map(b => ({ ...b, embedUrl: toEmbedUrl(b.videoUrl) })).filter(b => b.embedUrl);
            if (!videoBlogs.length) return null;

            const VideoFrame = ({ src, title }) => (
              <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', borderRadius: 12, overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.08)' }}>
                <iframe
                  src={src}
                  title={title}
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
            );

            if (videoBlogs.length <= 3) {
              return (
                <Row gutter={[24, 24]}>
                  {videoBlogs.map(v => (
                    <Col key={v._id} xs={24} md={12} lg={8}>
                      <Card
                        hoverable
                        bodyStyle={{ padding: 16 }}
                        style={{ borderRadius: 12, display: 'flex', flexDirection: 'column' }}
                        cover={<VideoFrame src={v.embedUrl} title={v.title} />}
                      >
                        <h3 style={{ margin: 0, fontSize: 16, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', minHeight: 48 }}>{v.title}</h3>
                      </Card>
                    </Col>
                  ))}
                </Row>
              );
            }

            // Plus de 3 vidéos → slider auto sans flèches (3 cartes par slide)
            const chunk = (arr, size) => arr.reduce((acc, _, i) => (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc), []);
            const slides = chunk(videoBlogs, 3);
            return (
              <div style={{ maxWidth: 1200, margin: '0 auto' }}>
                <Carousel autoplay autoplaySpeed={4000} dots={false} infinite pauseOnHover draggable>
                  {slides.map((group, idx) => (
                    <div key={idx}>
                      <Row gutter={[24, 24]}>
                        {group.map(v => (
                          <Col key={v._id} xs={24} md={12} lg={8}>
                            <Card
                              hoverable
                              bodyStyle={{ padding: 16 }}
                              style={{ borderRadius: 12, display: 'flex', flexDirection: 'column' }}
                              cover={<VideoFrame src={v.embedUrl} title={v.title} />}
                            >
                              <h3 style={{ margin: 0, fontSize: 16, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', minHeight: 48 }}>{v.title}</h3>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  ))}
                </Carousel>
              </div>
            );
          })()}
        </div>
      </section>

      {/* Nos projets - Album d'images */}
      <section style={{ padding: '50px 0', background: '#fff' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: 800, marginBottom: 12, color: '#0f172a' }}>Nos <span className="hdr-green">Projets</span></h2>
            <p style={{ fontSize: '1rem', color: '#64748b', maxWidth: 600, margin: '0 auto', lineHeight: 1.6 }}>
              Découvrez nos réalisations et installations dans le domaine du courant faible
            </p>
          </div>

          <div style={{ maxWidth: 1200, margin: '0 auto' }}>
            <Carousel autoplay autoplaySpeed={4000} dots={false} infinite pauseOnHover draggable effect="fade" vertical>
              {(() => {
                const projects = [
                  { id: 1, src: '/images/COMPUS_DES_MINES_VERTES.jpeg', title: 'Campus des Mines Vertes' },
                  { id: 2, src: '/images/Leoni.png', title: 'Projet Leoni' },
                  { id: 3, src: '/images/marriott_marrakech.jpg', title: 'Marriott Marrakech' },
                  { id: 4, src: '/images/MYWAY.jpg', title: 'MyWay Project' },
                  { id: 5, src: '/images/NRO.jpg', title: 'NRO Installation' },
                  { id: 6, src: '/images/ONOMO_MASSIRA.jpg', title: 'Onomo Massira' },
                  { id: 7, src: '/images/PARCELLE_O.webp', title: 'Parcelle O' },
                  { id: 8, src: '/images/RELEX_HOTEL.png', title: 'Relex Hotel' },
                  { id: 9, src: '/images/SEWS.jpg', title: 'SEWS Project' },
                  { id: 10, src: '/images/TERMINUS.jpg', title: 'Terminus' },
                  { id: 11, src: '/images/THE_VIEW.jpeg', title: 'The View' }
                ];

                const chunk = (arr, size) => arr.reduce((acc, _, i) => (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc), []);
                const slides = chunk(projects, 3);

                return slides.map((group, slideIndex) => (
                  <div key={slideIndex}>
                    <Row gutter={[24, 24]}>
                      {group.map(project => (
                        <Col key={project.id} xs={24} md={12} lg={8}>
                          <div
                            style={{
                              position: 'relative',
                              borderRadius: 16,
                              overflow: 'hidden',
                              boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                              transition: 'all 0.3s ease',
                              cursor: 'pointer',
                              background: '#fff'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-8px)';
                              e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.2)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                            }}
                          >
                            <div style={{ position: 'relative', paddingTop: '75%', overflow: 'hidden' }}>
                              <img
                                src={encodeURI(project.src)}
                                alt={project.title}
                                style={{
                                  position: 'absolute',
                                  top: 0, left: 0,
                                  width: '100%', height: '100%',
                                  objectFit: 'cover',
                                  transition: 'transform 0.3s ease'
                                }}
                                onError={(e) => { e.currentTarget.src = '/images/1.jpg'; }}
                                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                              />
                              <div style={{
                                position: 'absolute',
                                bottom: 0, left: 0, right: 0,
                                background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                                padding: '20px 16px 16px',
                                color: 'white'
                              }}>
                                <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600, textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                                  {project.title}
                                </h3>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                ));
              })()}
            </Carousel>
          </div>
        </div>
      </section>

      {/* Témoignages */}
      <section className="rv-section">
        <div className="container">
          <div className="rv-header">
            <h2>Ils parlent de <span className="hdr-green">D</span>OMO<span className="hdr-green">E</span>LEC</h2>
          </div>
          {(() => {
            const reviews = [
              { id: 1, name: "Anas", initial: "A", date: "20/08/2024", note: 5, text: "Toujours au top, le site est intuitif et fonctionne de manière remarquable. BRAVO." },
              { id: 2, name: "Mohamed", initial: "M", date: "12/03/2024", note: 5, text: "Le site est bien construit, les produits se trouvent facilement. Rapide, efficace." },
              { id: 3, name: "Anissa", initial: "A", date: "10/07/2024", note: 5, text: "Le moteur de recherche fonctionne de mieux en mieux." },
              { id: 4, name: "Imane", initial: "I", date: "18/06/2024", note: 5, text: "Simple, rapide et efficace." },
              { id: 5, name: "Rachid", initial: "R", date: "02/05/2024", note: 5, text: "Equipe très pro, conseils pertinents et disponibilité." },
            ];
            const rvRef = React.createRef();
            const scrollRv = (dir) => {
              if (rvRef.current) rvRef.current.scrollBy({ left: dir * 320, behavior: 'smooth' });
            };
            return (
              <>
                <div className="rv-controls">
                  <button onClick={() => scrollRv(-1)} aria-label="Précédent"><i className="fas fa-arrow-left"></i></button>
                  <button onClick={() => scrollRv(1)} aria-label="Suivant"><i className="fas fa-arrow-right"></i></button>
                </div>
                <div className="rv-track" ref={rvRef}>
                  {reviews.map((r) => (
                    <article key={r.id} className="rv-card">
                      <div className="rv-stars">{"★".repeat(r.note)}</div>
                      <p className="rv-text">"{r.text}"</p>
                      <div className="rv-author">
                        <div className="rv-avatar">{r.initial}</div>
                        <div>
                          <strong className="rv-name">{r.name}</strong>
                          <span className="rv-date">{r.date}</span>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              </>
            );
          })()}
        </div>
      </section>
      <Newsletter />
    </div>
  );
};

export default Home;